/* eslint-disable prefer-destructuring */
/* eslint-disable max-len */
import axios from 'axios';
import Vue from 'vue';
import helpers from '../../mixins/helpers';

const state = {
  a: {},
  ex_accounts: [],
  selected_ex_account: {},
  monthCourses: [],
};

const getters = {
  curr_acc: () => state.a,
  admins: () => state.a.members,
  acc_owner: () => state.a.user_id,
  selected_ex_account: () => state.selected_ex_account,
  agreements: () => state.a.agreements,
  standbys: () => state.a.standby,
  supervisions: () => state.a.supervision,
  epochs: () => state.a.epochs,
  classes: () => state.a.classes,
  hours: () => state.a.hours,
  ex_accounts: () => state.ex_accounts,
  loading: () => state.loading,
  getMonthCourses: () => state.monthCourses,
};

const actions = {
  async save_mensacare(context, mensacare) {
    const result = await axios.post(`${helpers.apihost()}save_mensacare`, { mensacare });
    if (!result.data || result.data.mensacare !== mensacare) return false;
    context.commit('set_mensacare', mensacare);
    return true;
  },
  async save_agreements() {
    const result = await axios.post(`${helpers.apihost()}save_agreements`, state.a.agreements);
    return result;
  },
  async save_standby() {
    const result = await axios.post(`${helpers.apihost()}save_standby`, state.a.standby);
    return result;
  },
  async save_supervision() {
    const result = await axios.post(`${helpers.apihost()}save_supervision`, state.a.supervision);
    return result;
  },
  async load(context) {
    const result = await axios.get(`${helpers.apihost()}get_account`);
    context.commit('set_account', result.data[0]);
  },
  async add_epoch(context, payload) {
    const result = await axios.post(`${helpers.apihost()}add_epoch`, payload);
    if (result) {
      context.dispatch('load');
      return true;
    }
    return false;
  },
  async delete_epoch(context, payload) {
    const result = await axios.post(`${helpers.apihost()}del_epoch`, payload);
    if (result) {
      context.dispatch('load');
      return true;
    }
    return false;
  },
  async save_epoch(context, epochIndex) {
    const result = await axios.post(`${helpers.apihost()}save_epoch`,
      { epoch: context.state.a.epochs[epochIndex], index: epochIndex });
    if (result) {
      context.dispatch('load');
      return true;
    }
    return false;
  },
  async load_ex_accounts(context) {
    const result = await axios.get(`${helpers.apihost()}get_ex_accounts`);
    context.commit('set_ex_accounts', result.data);
    return result.data;
  },
  async loadMonthCourses(context, date) {
    const result = await axios.get(`${helpers.apihost()}loadMonthCourses/${date}`);
    context.commit('set_monthCourses', result.data);
    return result.data;
  },
  async add_account(context, payload) {
    const result = await axios.post(`${helpers.apihost()}add_account`, payload);
    if (result) {
      return true;
    }
    return false;
  },
  async editAccess(context, payload) {
    const result = await axios.post(`${helpers.apihost()}editAccess`, {
      params: {
        accessAllowed: payload,
        acct_id: state.selected_ex_account.id,
      },
    });
    if (result) {
      return true;
    }
    return false;
  },
  async change_rights(context, payload) {
    const result = await axios.post(`${helpers.apihost()}change_rights`, {
      params: {
        payload,
      },
    });
    if (result) {
      return true;
    }
    return false;
  },
  async del_user(context, payload) {
    const user = {
      userId: payload,
      rights: {
        acc: false,
        group: false,
        training: false,
        assignment: false,
      },
    };
    context.dispatch('change_rights', user);
    const result = await axios.post(`${helpers.apihost()}del_acc_user`, {
      params: {
        userId: payload,
      },
    });
    if (result) {
      context.dispatch('load');
      return true;
    }
    return false;
  },
};

const mutations = {
  set_mensacare(s, mensacare) {
    state.a = { ...state.a, mensacare };
  },
  set_account(s, data) {
    state.a = data || {};

    if (!Array.isArray(state.a.supervision)) {
      state.a.supervision = [];
    }
  },
  set_teacher_epoch(s, data) {
    if (!data.teacher) return;
    const row = s.a.epochs[data.epochIndex].classes[data.classIndex];
    Vue.set(row, 'teacher', {
      firstname: data.teacher.firstname,
      lastname: data.teacher.lastname,
      id: data.teacher.id,
    });
  },
  set_ex_accounts(s, data) {
    state.ex_accounts = data;
    if (state.selected_ex_account === []) {
      state.selected_ex_account = data[0];
    }
  },
  set_monthCourses(s, data) {
    state.monthCourses = data;
  },
  change_selected_acc(s, account) {
    state.selected_ex_account = account;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
